/// <reference path="../../lib/jQuery.d.ts" />
import * as THREE from 'three'

import { Utils } from "../core/utils";

function toVec3(pos, height?) {
  height = height || 0;
  return new THREE.Vector3(pos.x, height, pos.y);
}

function isFiniteVector3(v: THREE.Vector3) {
  return isFinite(v.x) && isFinite(v.y) && isFinite(v.z);
}
function buildSideFillter(p1, p2, height, color) {
  var points = [
    toVec3(p1),
    toVec3(p2),
    toVec3(p2, height),
    toVec3(p1, height)
  ];

  if (!isFinite(height) || !isFiniteVector3(points[0]) || !isFiniteVector3(points[1]) || !isFiniteVector3(points[2]) || !isFiniteVector3(points[3])) {
    return null;
  }

  var geometry = new THREE.BufferGeometry().setFromPoints(points);
  let indices = new Uint16Array( [
    0, 1, 2,
    0, 2, 3
  ] );
  geometry.setIndex( new THREE.BufferAttribute( indices, 1 ) );
/*
check logic change
points.forEach((p) => {
    geometry.vertices.push(p);
  });
  geometry.faces.push(new THREE.Face3(0, 1, 2));
  geometry.faces.push(new THREE.Face3(0, 2, 3));
*/

  var fillerMaterial = new THREE.MeshStandardMaterial({
    color: color,
    side: THREE.DoubleSide,
    roughness: 0.92,
    metalness: 0.02
  });

  var filler = new THREE.Mesh(geometry, fillerMaterial);
  filler.castShadow = true;
  filler.receiveShadow = true;
  return filler;
}
function buildTopFillter(edge, height, color) {
  var points = [
    toVec3(edge.interiorStart(), height),
    toVec3(edge.interiorEnd(), height),
    toVec3(edge.exteriorEnd(), height),
    toVec3(edge.exteriorStart(), height)
  ];

  if (!isFinite(height) || !isFiniteVector3(points[0]) || !isFiniteVector3(points[1]) || !isFiniteVector3(points[2]) || !isFiniteVector3(points[3])) {
    return null;
  }

  var geometry = new THREE.BufferGeometry().setFromPoints(points);
  let indices = new Uint16Array([
    0, 1, 2,
    0, 2, 3
  ]);
  geometry.setIndex(new THREE.BufferAttribute(indices, 1));
  geometry.computeVertexNormals();

  var fillerMaterial = new THREE.MeshStandardMaterial({
    color: color,
    side: THREE.DoubleSide,
    roughness: 0.92,
    metalness: 0.02
  });

  var top = new THREE.Mesh(geometry, fillerMaterial);
  top.castShadow = true;
  top.receiveShadow = true;
  return top;
}

export var Edge = function (scene, edge, controls) {
    var scope = this;
    var scene = scene;
    var edge = edge;
    var controls = controls;
    var wall = edge.wall;
    var front = edge.front;

    var planes = [];
    var basePlanes = []; // always visible
    var texture = null;
    var textureUrl = null;
    var textureLoader = new THREE.TextureLoader();

    var lightMap = textureLoader.load("rooms/textures/walllightmap.png");
    var fillerColor = 0xdddddd;
    var sideColor = 0xcccccc;
    var baseColor = 0xdddddd;
    var hovered = false;

    this.visible = false;

    this.remove = function () {
      edge.redrawCallbacks.remove(redraw);
      edge.hoverCallbacks.remove(setHovered);
      controls.cameraMovedCallbacks.remove(updateVisibility);
      removeFromScene();
    }

    function init() {
      edge.redrawCallbacks.add(redraw);
      edge.hoverCallbacks.add(setHovered);
      controls.cameraMovedCallbacks.add(updateVisibility);
      updateTexture();
      updatePlanes();
      setHovered(edge.isHovered());
      addToScene();
    }

    function redraw() {
      removeFromScene();
      updateTexture();
      updatePlanes();
      setHovered(edge.isHovered());
      addToScene();
    }

    function removeFromScene() {
      planes.forEach((plane) => {
        scene.remove(plane);
      });
      basePlanes.forEach((plane) => {
        scene.remove(plane);
      });
      planes = [];
      basePlanes = [];
    }

    function addToScene() {
      planes.forEach((plane) => {
        scene.add(plane);
      });
      basePlanes.forEach((plane) => {
        scene.add(plane);
      });
      updateVisibility();
    }

    function updateVisibility() {
      // finds the normal from the specified edge
      var start = edge.interiorStart();
      var end = edge.interiorEnd();
      var x = end.x - start.x;
      var y = end.y - start.y;
      // rotate 90 degrees CCW
      var normal = new THREE.Vector3(-y, 0, x);
      normal.normalize();

      // setup camera
      var position = controls.object.position.clone();
      var focus = new THREE.Vector3(
        (start.x + end.x) / 2.0,
        0,
        (start.y + end.y) / 2.0);
      var direction = position.sub(focus).normalize();

      // find dot
      var dot = normal.dot(direction);

      // update visible
      scope.visible = (dot >= 0);

      // show or hide plans
      planes.forEach((plane) => {
        plane.visible = scope.visible;
      });

      updateObjectVisibility();
    }

    function updateObjectVisibility() {
      wall.items.forEach((item) => {
        item.updateEdgeVisibility(scope.visible, front);
      });
      wall.onItems.forEach((item) => {
        item.updateEdgeVisibility(scope.visible, front);
      });
    }

    function setHovered(active: boolean) {
      hovered = !!active;
      applyHoverState();
    }

    function applyHoverState() {
      var emissiveLevel = hovered ? 0.1 : 0;
      var allPlanes = planes.concat(basePlanes);
      allPlanes.forEach((plane: any) => {
        var apply = function(material: any) {
          if (!material || !material.emissive || !material.emissive.isColor) {
            return;
          }
          material.emissive.setRGB(emissiveLevel, emissiveLevel, emissiveLevel);
          material.needsUpdate = true;
        };

        if (Array.isArray(plane.material)) {
          plane.material.forEach((material) => apply(material));
        } else {
          apply(plane.material);
        }
      });
      scene.needsUpdate = true;
    }

    function updateTexture(callback?) {
      // callback is fired when texture loads
      callback = callback || function () {
        scene.needsUpdate = true;
      }

      var textureData = edge.getTexture();
      var stretch = textureData.stretch;
      var url = textureData.url;
      var scale = textureData.scale;

      function applyTextureSettings() {
        if ((THREE as any).SRGBColorSpace !== undefined && texture) {
          (texture as any).colorSpace = (THREE as any).SRGBColorSpace;
        } else if ((THREE as any).sRGBEncoding !== undefined && texture) {
          (texture as any).encoding = (THREE as any).sRGBEncoding;
        }
        if (!texture) {
          return;
        }

        if (!stretch && scale > 0) {
          var height = wall.height;
          var width = edge.interiorDistance();
          texture.wrapT = THREE.RepeatWrapping;
          texture.wrapS = THREE.RepeatWrapping;
          texture.repeat.set(width / scale, height / scale);
        } else {
          texture.wrapT = THREE.ClampToEdgeWrapping;
          texture.wrapS = THREE.ClampToEdgeWrapping;
          texture.repeat.set(1, 1);
        }

        if ((texture as any).image && (texture as any).image.width) {
          texture.needsUpdate = true;
        }
      }

      if (!texture || textureUrl !== url) {
        textureUrl = url;
        texture = textureLoader.load(url, function () {
          applyTextureSettings();
          callback();
        });
        applyTextureSettings();
        return;
      }

      applyTextureSettings();
      callback();
    }
    function updatePlanes() {
      var wallMaterial = new THREE.MeshStandardMaterial({
        color: 0xffffff,
        side: THREE.DoubleSide,
        map: texture,
        roughness: 0.9,
        metalness: 0.02
      });

      var fillerMaterial = new THREE.MeshStandardMaterial({
        color: fillerColor,
        side: THREE.DoubleSide,
        roughness: 0.92,
        metalness: 0.02
      });

      // exterior plane
      var exteriorWall = makeWall(
        edge.exteriorStart(),
        edge.exteriorEnd(),
        edge.exteriorTransform,
        edge.invExteriorTransform,
        wallMaterial);
      if (exteriorWall) {
        planes.push(exteriorWall);
      }

      // interior plane
      var interiorWall = makeWall(
        edge.interiorStart(),
        edge.interiorEnd(),
        edge.interiorTransform,
        edge.invInteriorTransform,
        wallMaterial);
      if (interiorWall) {
        planes.push(interiorWall);
      }

      // bottom
      // put into basePlanes since this is always visible
      /* Issue:  -- buildfiller doesn't seem to exist
      basePlanes.push(buildFiller(
        edge, 0,
        THREE.BackSide, baseColor));

      // top
      planes.push(buildFiller(
        edge, wall.height,
        THREE.DoubleSide, fillerColor));
*/
      // sides
      var startSide = buildSideFillter(
        edge.interiorStart(), edge.exteriorStart(),
        wall.height, sideColor);
      if (startSide) {
        planes.push(startSide);
      }

      var endSide = buildSideFillter(
        edge.interiorEnd(), edge.exteriorEnd(),
        wall.height, sideColor);
      if (endSide) {
        planes.push(endSide);
      }

      // Add the top cap once per wall so walls appear solid from overhead.
      if (front || !wall.backEdge) {
        var topFiller = buildTopFillter(edge, wall.height, sideColor);
        if (topFiller) {
          basePlanes.push(topFiller);
        }
      }

      applyHoverState();
    }

    // start, end have x and y attributes (i.e. corners)
    function makeWall(start, end, transform, invTransform, material) {
      if (!start || !end || !transform || !invTransform) {
        return null;
      }

      if (!isFinite(start.x) || !isFinite(start.y) || !isFinite(end.x) || !isFinite(end.y)) {
        return null;
      }

      if (Utils.distance(start.x, start.y, end.x, end.y) < 0.01) {
        return null;
      }

      var v1 = toVec3(start);
      var v2 = toVec3(end);
      var v3 = v2.clone();
      v3.y = wall.height;
      var v4 = v1.clone();
      v4.y = wall.height;

      var points = [v1.clone(), v2.clone(), v3.clone(), v4.clone()];

      points.forEach((p) => {
        p.applyMatrix4(transform);
      });

      if (!isFiniteVector3(points[0]) || !isFiniteVector3(points[1]) || !isFiniteVector3(points[2]) || !isFiniteVector3(points[3])) {
        return null;
      }

      var shape = new THREE.Shape([
        new THREE.Vector2(points[0].x, points[0].y),
        new THREE.Vector2(points[1].x, points[1].y),
        new THREE.Vector2(points[2].x, points[2].y),
        new THREE.Vector2(points[3].x, points[3].y)
      ]);

      // add holes for each wall item
      wall.items.forEach((item) => {
        var pos = item.position.clone();
        pos.applyMatrix4(transform)
        var halfSize = item.halfSize;
        var min = halfSize.clone().multiplyScalar(-1);
        var max = halfSize.clone();
        min.add(pos);
        max.add(pos);

        var holePoints = [
          new THREE.Vector2(min.x, min.y),
          new THREE.Vector2(max.x, min.y),
          new THREE.Vector2(max.x, max.y),
          new THREE.Vector2(min.x, max.y)
        ];

        shape.holes.push(new THREE.Path(holePoints));
      });

      var geometry:THREE.BufferGeometry = new THREE.ShapeGeometry(shape);
      let vertices = geometry.getAttribute("position");
      let tVertex = new THREE.Vector3();
      for(let i = 0; i < vertices.count; i++) {
        tVertex.fromBufferAttribute(vertices, i);
        tVertex.applyMatrix4(invTransform);
        if (!isFiniteVector3(tVertex)) {
          return null;
        }
        vertices.setXYZ(i, tVertex.x, tVertex.y, tVertex.z);
      }
      /* check above logic replacement
      geometry.vertices.forEach((v) => {
        v.applyMatrix4(invTransform);
      });
      */

      // make UVs
      var totalDistance = Utils.distance(v1.x, v1.z, v2.x, v2.z);
      var height = wall.height;
      var safeDistance = Math.max(0.0001, totalDistance);
      var safeHeight = Math.max(0.0001, Math.abs(height));
//      geometry.faceVertexUvs[0] = [];

      function vertexToUv(vertex) {
        var x = Utils.distance(v1.x, v1.z, vertex.x, vertex.z) / safeDistance;
        var y = vertex.y / safeHeight;
        if (!isFinite(x)) {
          x = 0;
        }
        if (!isFinite(y)) {
          y = 0;
        }
        return new THREE.Vector2(x, y);
      }
      let vertA = new THREE.Vector3();
      let uvA;

      let pos = geometry.getAttribute("position") as THREE.BufferAttribute;
      let uvs = geometry.getAttribute("uv") as THREE.BufferAttribute;
      if (!uvs) {
        uvs = new THREE.BufferAttribute(new Float32Array(pos.count * 2), 2);
        geometry.setAttribute("uv", uvs);
      }

      for (let i = 0; i < pos.count; i++) {
        vertA.fromBufferAttribute(pos, i);
        uvA = vertexToUv(vertA);
        (uvs as THREE.BufferAttribute).setXY(i, uvA.x, uvA.y);
      }
      (uvs as THREE.BufferAttribute).needsUpdate = true;
      geometry.computeVertexNormals();

      var mesh = new THREE.Mesh(
        geometry,
        material);

      mesh.castShadow = true;
      mesh.receiveShadow = true;
      return mesh;
    }


    function toVec2(pos) {
      return new THREE.Vector2(pos.x, pos.y);
    }


    init();
}


